import { render, staticRenderFns } from "./ScreenList.vue?vue&type=template&id=090a4f5a&scoped=true"
import script from "./ScreenList.vue?vue&type=script&lang=js"
export * from "./ScreenList.vue?vue&type=script&lang=js"
import style0 from "./ScreenList.vue?vue&type=style&index=0&id=090a4f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a4f5a",
  null
  
)

export default component.exports